import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-solid-svg-icons';

import Modal from 'bundles/apex/playbooks/config/tasks/copy_modal';

import './styles.scss';

export default function CopyTask() {
  const [showModal, setShowModal] = useState();

  return <React.Fragment>
    <a className="task-copy-control ml-4" onClick={() => setShowModal(true)}>
      <FontAwesomeIcon className="mr-2" icon={faCopy} />
      Copy Tasks
    </a>

    <Modal
      className="playbook-copy-task-modal"
      show={showModal}
      onHide={() => setShowModal(false)}
    />
  </React.Fragment>;
}
